import { HourResponse } from '../models/HourResponse';

export class Hour {
	weekday: number;
	openedAt: Date;
	closedAt: Date;

	constructor(hourRes: HourResponse, currWeekDay: number) {
		if (!hourRes?.openedAt || !hourRes?.closedAt) return null;

		const openedAt = new Date();
		const closedAt = new Date();

		openedAt.setDate(openedAt.getDate() + hourRes.weekday - currWeekDay);
		closedAt.setDate(closedAt.getDate() + hourRes.weekday - currWeekDay);

		openedAt.setHours(+hourRes.openedAt.split(':')[0] + 2, +hourRes.openedAt.split(':')[1], 0);
		closedAt.setHours(+hourRes.closedAt.split(':')[0] + 2, +hourRes.closedAt.split(':')[1], 0);

		if (currWeekDay > hourRes.weekday) {
			//For days of the week that have already passed, we set the day from the following week.
			openedAt.setDate(openedAt.getDate() + 7);
			closedAt.setDate(closedAt.getDate() + 7);
		}

		if (openedAt.getTime() > closedAt.getTime()) openedAt.setDate(closedAt.getDate() - 1);

		this.weekday = hourRes.weekday;
		this.openedAt = openedAt;
		this.closedAt = closedAt;
	}
}
